<template>
    <f7-list
            media-list
            virtual
            :virtual-rows-after="virtualRowsAfter"
            :virtual-items="virtualItems"
            :virtual-height="virtualHeight"
            :virtual-render-item="renderItem">
    </f7-list>
</template>

<style>
    .list-block.virtual-list ul:after, .list-block.virtual-list ul:before {
        display: none;
    }
    .list-block.virtual-list li .card {
        margin: 0;
    }
    .list-block.virtual-list li {
        margin: 8px;
    }
</style>

<script>
    export default {
        data: function () {
            return {
                alias: '',
            }
        },
        props: [
            'name',
            'virtualItems',
            'virtualHeight',
            'renderItemHeader',
            'renderItemFooter',
            'renderItemContent',
            'onItemClick',
        ],
        computed: {
            virtualRowsAfter: function () {
                let self = this;

                return Math.round(self.$$(window).height() / self.virtualHeight) * 2;
            }
        },
        methods: {
            renderItem: function (index, item) {
                let self = this;

                let content = self.renderItemContent(index, item);
                if (content) {
                    content = '<div class="card-content"><div class="card-content-inner">' + content + '</div></div>';
                }

                let disabled = item.disabled ? 'disabled' : '';
                let ret =
                    '<li onclick="f7[\'' + self.alias + '\'].itemClick(' + index + ')">' +
                    '<div class="card ' + disabled + '">' +
                    '<div class="card-header">' +
                    self.renderItemHeader(index, item) +
                    '<span class="chip"><span class="chip-label">' + (index + 1) + '</span></span>' +
                    '</div>' +
                    content +
                    '<div class="card-footer">' +
                    self.renderItemFooter(index, item) +
                    '</div>' +
                    '</div>' +
                    '</li>';

                return ret;
            },
            itemClick: function (index) {
                let item = this.virtualItems[index];
                let action = this.$$(event.target).attr('data-action');

                //console.log('onItemClick from virtualcards');
                this.$emit('onItemClick', index, item, action);
            }
        },
        created: function () {
            let self = this;
            self.alias = '$myvc-' + self.name;

            this.$f7[self.alias] = this;

            //window.v = this;
        }
    }
</script>



// WEBPACK FOOTER //
// VVirtualCards.vue?369750e2